<template>
  <div>
    <!-- SERVICE SCOPE -->
    <div class="d-flex flex-row flex-wrap mb-4">
      <v-spacer />

      <div class="d-flex flex-row elevation-1 px-2 pt-4">
        <v-radio-group
          :value="scopeServices"
          row
          class="mt-0"
          @change="$emit('change-scope', $event)"
        >
          <v-radio
            label="Active"
            value="active"
            class="my-0 py-0"
          />

          <v-radio
            label="PackageMaker"
            value="packagemaker"
            class="my-0 py-0"
          />

          <v-radio
            label="Website"
            value="website"
            class="my-0 py-0"
          />

          <v-radio
            label="Inactive"
            value="inactive"
            class="my-0 py-0"
          />

          <v-radio
            label="All"
            value="all"
            class="my-0 py-0"
          />
        </v-radio-group>
      </div>

      <v-spacer />
    </div>

    <!-- SERVICE TABLE -->
    <v-data-table
      :headers="headers"
      :items="services"
      :items-per-page="-1"
      :sort-by="sortServices"
      :sort-desc="sortDirection"
      :search="searchServices"
      class="elevation-1"
      disable-pagination
      hide-default-footer
      @update:sort-by="changeSort"
      @update:sort-desc="changeSortDirection"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <v-toolbar-title>
            Catalog
          </v-toolbar-title>

          <v-spacer />

          <v-card flat>
            <v-text-field
              v-model="searchServices"
              append-icon="$vuetify.icons.icon_mdi_magnify"
              :label="'Search ' + services.length + ' service(s)'"
              single-line
              hide-details
              style="width: 300px"
              clearable
            />
          </v-card>

          <v-spacer />

          <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="ppc_pink"
                    dark
                    small
                    absolute
                    right
                    fab
                    @click="$emit('add-new-service')"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      $vuetify.icons.icon_mdi_plus
                    </v-icon>
                  </v-btn>
              </template>
              <span>Add a Service</span>
          </v-tooltip>

        </v-toolbar>
      </template>

      <!-- ICON -->
      <template v-slot:[`item.icon`]="{ item }">
        <v-icon v-text="item.icon" />
      </template>

      <!-- ACTIVE -->
      <template v-slot:[`item.active`]="{ item }">
        <v-icon
          v-if="`${item.active}` === '1'"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>

      <!-- PACKAGE MAKER -->
      <template v-slot:[`item.packageMaker`]="{ item }">
        <v-icon
          v-if="`${item.packageMaker}` === '1'"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>

      <!-- WEBSITE -->
      <template v-slot:[`item.website`]="{ item }">
        <v-icon
          v-if="`${item.website}` === '1'"
          small
          color="ppc_darkgreen"
        >
          $vuetify.icons.icon_mdi_check
        </v-icon>
      </template>

      <!-- ACTIONS -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="$emit('edit', item.service_number)"
        >
          $vuetify.icons.icon_mdi_pencil
        </v-icon>

        <v-icon
          small
          @click="$emit('delete', item.service_number)"
        >
          $vuetify.icons.icon_mdi_delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'ServiceList',

  props: {
    services: {
      type: Array,
      default: () => [],
    },

    scopeServices: {
      type: String,
      default: 'active',
    },
  },

  data() {
    return {
      searchServices: '',
      sortServices: 'agency_name',
      sortDirection: true,
    }
  },

  computed: {
    headers() {
      return [
        {
          text: null,
          value: 'icon',
          sortable: false,
        },
        {
          text: 'Nr',
          align: 'start',
          value: 'service_number',
        },
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Agency',
          value: 'agency_name',
        },
        {
          text: 'Type',
          value: 'type',
        },
        {
          text: 'Active',
          value: 'active',
        },
        {
          text: 'PM',
          value: 'packageMaker',
        },
        {
          text: 'Website',
          value: 'website',
        },
        {
          text: 'Applied',
          value: 'amountUsed',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },

  methods: {
    changeSort(value) {
      this.sortServices = value;
    },

    changeSortDirection(value) {
      this.sortDirection = value;
    },
  },
}
</script>